import { SITE } from "@/data/site"

function Fragrance() {
  return (
    <section id="fragrance" className="relative w-full bg-[#080808] px-8 pb-32 pt-16 md:px-16 md:pb-40 md:pt-20 lg:px-28 lg:pt-16">
      <div className="grid w-full items-start gap-10 lg:grid-cols-12 lg:gap-16">
        <div className="lg:col-span-7">
          <p className="font-sans-ui text-[11px] tracking-[0.48em] text-[#c4a574]">05</p>
          <p className="font-sans-ui mt-4 text-[11px] tracking-[0.4em] text-stone-500">限定珍藏香氛</p>
          <div className="relative mt-8 overflow-hidden bg-[#111111] lg:mt-10">
            <img
              src={SITE.productMain}
              alt={SITE.productName}
              decoding="async"
              className="mx-auto h-auto max-h-[90vh] w-full object-contain object-center md:max-h-[92vh]"
            />
          </div>
        </div>
        <div className="lg:col-span-5">
          <h2 className="font-display text-4xl leading-none text-[#f7f1e6] md:text-7xl">{SITE.productName}</h2>
          <div className="font-sans-ui mt-6 w-full space-y-5 text-center text-[11px] leading-6 tracking-normal text-stone-400 md:mt-8 md:space-y-7 md:text-sm md:leading-8 md:tracking-wide">
            <p>大家好，我們是野東西。</p>
            <p>
              這件作品靈感來自《Free Man》這張專輯，我們想把音樂裡「不被定義、不迎合」的自由，變成一種氣味。
            </p>
            <p>
              以芫荽籽、絲柏與威士忌，描寫離開人群、走進森林的瞬間；小蒼蘭、天芥菜與岩薔薇，讓花香多了一點野性。
            </p>
            <p>
              最後以覆盆子、廣藿香、皮革與柏木收尾，溫暖、乾燥而深沉。
            </p>
            <p>
              就像走過一段路後，留下的不是裝扮，而是真正屬於自己的痕跡。
            </p>
            <h3 className="font-display pt-8 text-xl leading-snug tracking-wide text-[#f7f1e6] md:pt-10 md:text-2xl">
              因為真正的自由，就是不再需要別人替你定義。
            </h3>
          </div>
          <div className="mx-auto mt-10 max-w-xs space-y-3 border-t border-white/10 pt-8 text-center md:mt-12">
            <p className="font-sans-ui text-[11px] tracking-[0.16em] text-stone-400 md:text-sm md:tracking-[0.28em]">{SITE.volume}</p>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Fragrance
